<template>
	<div class="item-wrapper" v-if="item">
		<div class="top">
			<div class="preview-container">
				<div class="title-container" @click="goToSliderItem(item)">
					<div class="title">
						<b v-text="item.title"/>
					</div>
				</div>
				<div class="preview-block">
					<div class="preview" v-if="lazy">
						<img v-if="item.product_type == 'image'" :data-lazy="imgDomain + item.doc_url" class="img"/>
						<div v-else class="doc-img">
							<img src='./../images/doc.svg' class="img"/>
						</div>
					</div>
					<div class="preview" v-else>
						<img v-if="item.product_type == 'image'" :src="imgDomain + item.doc_url" class="img"/>
						<div v-else class="doc-img">
							<img src='./../images/doc.svg' class="img"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div :class="['bottom', {'bottom-doc': item.product_type !== 'image'}]">
			<div class="desc-container">
				<div class="desc" v-html="item.description"></div>
				<div 
					v-if="item.description.length > 150" 
					class="desc link" v-html="'Read more'" 
					@click="goToSliderItem(item)"	
				/>
			</div>
			<transition name="fade">
				<span class="desc green" v-if="addToCartChosenItem == item.id && !error">{{ $t('Item successfully added to your cart') }}</span>
			</transition>
			<transition name="fade">
				<span class="desc red" v-if="addToCartChosenItem == item.id && error">{{ error }}</span>
			</transition>
			<div class="price title" @click="openReadyModal(item)">
				<span class="add-desc">{{ $t('PURCHASE PRODUCT') }}</span>
				<span class="price-desc">[ {{item.price}} <InternalCurrency/> ]</span>
			</div>
		</div>
	</div>
</template>

<script>

import InternalCurrency from "@/components/InternalCurrency.vue";

export default {
	name: 'ProductCard',
  components: {InternalCurrency},
	props: ['item', 'sliderIsClickble', 'currency', 'isAuth', 'lazy', 'categories', 'addToCartChosenItem', 'error'],
	data: function() {
		return {
			imgDomain: '',
			tag: ''
		}
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	methods: {
    openReadyModal(item) {
      this.$emit('openReadyModal', item)
    },
		isNumber(variable) {
			return Number.isFinite(variable) && typeof variable === "number";
		},
		goToSliderItem(item) {
			let self = this;
			setTimeout(()=> {
				if (self.sliderIsClickble == true) {
					self.$emit('goToProduct', item);
				}
			}, 200)
		},
		getPack() {
			if (this.isAuth) {
				this.openReadyModal();
			} else {
				this.openSignInModal();
			}
		},
		openSignInModal() {
			this.$emit('openSignInModal');
		},
		openBuyModal(item, type) {
			this.$emit('openBuyModal', item, type)
		}
	},
}
</script>
